import { createSelector } from 'reselect';

const appSelector = state => state.app;

export const userSelector = createSelector(appSelector, ({ user }) => user);

export const isAdviserSelector = createSelector(appSelector, ({ user }) => user.Role === 2);

export const infoSelector = createSelector(appSelector, ({ info }) => info);

export const versionSelector = createSelector(infoSelector, ({ version }) => version);

export const endpointsSelector = createSelector(appSelector, ({ endpoints }) => endpoints);

export const tokensSelector = createSelector(appSelector, ({ tokens }) => tokens);

export const selectHiddenLeversRtqUrl = createSelector(
  endpointsSelector,
  ({ hiddenLeversRtqUrl }) => hiddenLeversRtqUrl,
);
